import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';

const Sidebar: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="sidebar">
      <nav>
        <ul className="sidebar-list">
          <li><Link to="/dashboard" className="sidebar-link">Dashboard</Link></li>
          <li><Link to="/pos" className="sidebar-link">Punto de Venta</Link></li>
          <li><Link to="/productos" className="sidebar-link">Productos</Link></li>
          <li><Link to="/proveedores" className="sidebar-link">Proveedores</Link></li>
          <li><Link to="/recepcion" className="sidebar-link">Recepción de Mercancía</Link></li>
          <li><Link to="/recepcion/historial" className="sidebar-link">Historial Facturas</Link></li>
          <li><Link to="/categorias" className="sidebar-link">Categorías</Link></li>
          <li><Link to="/operaciones" className="sidebar-link">Operaciones</Link></li>
          <li><Link to="/ubicaciones" className="sidebar-link">Ubicaciones</Link></li>
          <li><Link to="/mapa-bodega" className="sidebar-link">Mapa de Bodega</Link></li>
          <li><Link to="/conteo-ciego" className="sidebar-link" style={{ color: '#ff9800' }}>Conteo Ciego</Link></li>
          <li><Link to="/users" className="sidebar-link">Usuarios</Link></li>
        </ul>
      </nav>

      <div className="menu-divider"></div>

      <button
        className="logout-button"
        onClick={handleLogout}
      >
        <span>🚪</span>
        Cerrar Sesión
      </button>
    </aside>
  );
};

export default Sidebar;